import { defineComponent, h } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { SelectOptions } from '@/ui/types';
import { TagField } from '@/ui/components/form';
import { ValidationError } from '@/entities/validation';
import { VDataComponents } from '@/ui/helpers';

interface ChooseGroupFieldProps {
  options: SelectOptions;
  value: number[];
  errors: ValidationError[];
  disabled?: boolean;
  required?: boolean;
  label?: string;
  placeholder?: string;
  identifier?: string;
  hideLabel?: boolean;
}

export const ChooseGroupField = defineComponent<ChooseGroupFieldProps>({
  props: ['options', 'value', 'errors', 'label', 'placeholder', 'identifier', 'hideLabel', 'required'],
  setup(props, ctx) {
    return function render() {
      return h('div', [
        h(TagField, {
          props: {
            value: props.value,
            options: props.options,
            disabled: false,
            placeholder: props.placeholder ?? t('role.groups-placeholder'),
            label: props.label ?? t('role.groups'),
            name: 'groups',
            required: props.required,
            errors: props.errors,
            hideLabel: props.hideLabel,
          },
          on: {
            input: (value: Array<string | number>) => ctx.emit('input', value),
          },
        }),
      ]);
    };
  },
});

export const chooseGroupField = (data: VDataComponents<ChooseGroupFieldProps>) => h(ChooseGroupField, data);
